import { Injectable, inject } from '@angular/core';
import { OperationTypeEnum } from '@data-access/bulk-operations-api';
import { FeatureFlagService } from '@feature-flag';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
@UntilDestroy()
export class DisabledOperationService {
  private featureFlagService = inject(FeatureFlagService);

  private _disabledOperations = new BehaviorSubject<{ [key: string]: boolean }>({});

  constructor() {
    this.getFeatureToggles();
  }

  getDisabledOperations(): Observable<{ [key: string]: boolean }> {
    return this._disabledOperations.asObservable();
  }

  private getFeatureToggles(): void {
    combineLatest([
      this.featureFlagService.getFlagValue('disable-salary-update-service'),
      this.featureFlagService.getFlagValue('disable-ending-of-fixed-transactions'),
      this.featureFlagService.getFlagValue('disable-vacation-balances'),
      this.featureFlagService.getFlagValue('disable-bulk-edit-tags'),
      this.featureFlagService.getFlagValue('disable-absence-import'),
      this.featureFlagService.getFlagValue('disable-bulk-end-positions'),
      this.featureFlagService.getFlagValue('disable-bulk-create-user'),
      this.featureFlagService.getFlagValue('disable-bulk-edit-manager'),
      this.featureFlagService.getFlagValue('disable-bulk-rates-update'),
      this.featureFlagService.getFlagValue('disable-bulk-edit-fixed-transactions'),
    ])
      .pipe(untilDestroyed(this))
      .subscribe(
        ([
          salaryUpdateServiceToggle,
          endFixedTransactionServiceToggle,
          vacationBalanceImportToggle,
          bulkTagsEditToggle,
          absenceImportToggle,
          endPositionsToggle,
          bulkCreateUserToggle,
          bulkEditManagerToggle,
          bulkRatesUpdateToggle,
          bulkEditFixedTransactionsToggle,
        ]) => {
          this._disabledOperations.next({
            [OperationTypeEnum.SalaryUpdateV2]: salaryUpdateServiceToggle,
            [OperationTypeEnum.EndFixedTransactions]: endFixedTransactionServiceToggle,
            [OperationTypeEnum.VacationBalanceImport]: vacationBalanceImportToggle,
            [OperationTypeEnum.PositionTagsUpdate]: bulkTagsEditToggle,
            [OperationTypeEnum.AbsenceRegistrationImport]: absenceImportToggle,
            [OperationTypeEnum.EndPositions]: endPositionsToggle,
            [OperationTypeEnum.AssignUser]: bulkCreateUserToggle,
            [OperationTypeEnum.ChangeManager]: bulkEditManagerToggle,
            [OperationTypeEnum.PayRateUpdate]: bulkRatesUpdateToggle,
            [OperationTypeEnum.EditFixedTransactions]: bulkEditFixedTransactionsToggle,
          });
        },
      );
  }
}
